import { useEffect } from 'react';
import { Layout } from '@/components/layout/Layout';

const Press = () => {
  useEffect(() => {
    document.title = 'Press & Media | Diamond Club Matchmaking';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Featured press and media coverage highlighting Diamond Club Matchmaking, leadership, and modern relationship culture.');
    }
  }, []);

  const features = [
    {
      title: 'Forbes Feature',
      publication: 'Forbes',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/52g9m8hk_Press%201.jpeg',
    },
    {
      title: 'Cover Feature',
      publication: 'Celebrity',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/02grq723_Press%202.jpg',
    },
    {
      title: 'Cover Story',
      publication: 'Los Angeles Business',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/dzjbupq8_Press%203.jpeg',
    },
    {
      title: 'Cover Feature',
      publication: 'FHM',
      image: 'https://customer-assets.emergentagent.com/job_4a089f9d-01a6-4529-ac94-ec15e169186e/artifacts/qtd83i4y_IMG_7734.jpeg',
    },
    {
      title: 'Cover Feature',
      publication: "Harper's Bazaar",
      image: 'https://customer-assets.emergentagent.com/job_4a089f9d-01a6-4529-ac94-ec15e169186e/artifacts/pifrr0k0_IMG_7741.jpeg',
    },
    {
      title: 'Cover Story',
      publication: 'Women Journey',
      image: 'https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/cg849gys_Press%206.JPG',
    },
  ];

  const outlets = [
    'Forbes',
    'MILLENNIUM',
    'MY IMPERFECT LIFE',
    'CBS',
    'Giddy',
    'JAMO',
    'EXPRESS',
    'The List',
    'KCTV5',
    'BUSINESS INSIDER',
  ];

  return (
    <Layout>
      <section className="min-h-screen bg-black-deep grain-overlay shimmer">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
          {/* Page Title */}
          <div className="text-center mb-12">
            <h1 className="font-serif text-display-sm md:text-display text-cream italic mb-4">
              Press & Media
            </h1>
            <p className="font-sans text-cream-muted text-base">
              Featured coverage highlighting leadership, matchmaking, and modern relationship culture.
            </p>
          </div>
          
          {/* Decorative dividers around AS SEEN IN */}
          <div className="flex items-center justify-center gap-6 mb-12">
            <div className="flex-1 max-w-[100px] h-px bg-gradient-to-r from-transparent to-gold/50"></div>
            <span className="font-sans text-gold text-sm tracking-[0.3em] uppercase">As Seen In</span>
            <div className="flex-1 max-w-[100px] h-px bg-gradient-to-l from-transparent to-gold/50"></div>
          </div>
          
          {/* Magazine Cover Grid - 3x2 layout */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-16">
            {features.map((feature, index) => (
              <div key={index} className="group flex flex-col">
                {/* Cover image with fixed height, auto width */}
                <div className="relative h-[280px] md:h-[320px] lg:h-[360px] mb-3 rounded-sm overflow-hidden bg-black-soft flex items-center justify-center">
                  <img 
                    src={feature.image}
                    alt={feature.title}
                    className="h-full w-auto max-w-full object-contain"
                  />
                  {/* Shimmer effect on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-gold/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                
                {/* Caption */}
                <p className="font-sans text-cream text-center text-xs">
                  {feature.title}
                </p>
              </div>
            ))}
          </div>
          
          {/* Outlet Logos Row */}
          <div className="py-8 border-y border-gold/20 mb-12">
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
              {outlets.map((outlet) => (
                <span 
                  key={outlet}
                  className="font-serif text-gold/80 text-sm md:text-base tracking-wider"
                >
                  {outlet}
                </span>
              ))}
            </div>
          </div>
          
          {/* Media inquiries */}
          <p className="text-center font-sans text-cream-muted text-sm">
            Media inquiries available upon request.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Press;
